export default "/build/images/028-1.png?95c44cace3ec76ebf02ca10ee9925ff1";